/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".templates-header[_ngcontent-%COMP%]   ion-toolbar[_ngcontent-%COMP%]{--background:none}.templates-header-title[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.spinner[_ngcontent-%COMP%]{text-align:center;margin-top:45%}"];
export { styles as styles };
